import React from "react";
import { Link } from "react-router-dom";
import "./Landing.css";

export default function Landing() {
  return (
    <div className="landing">
      <section className="hero">
        <div className="container hero-inner">
          <div className="hero-copy">
            <h1>
              <span className="hero-line">One day, they'll leap.</span>{" "}
              <span className="hero-line">One day, they'll fly.</span>
            </h1>
            <h2>Today, we’ll support them one step at a time.</h2>
            <p>
              Our founders are NICU mothers. They know firsthand what these
              families need, because they needed it too.
            </p>
            <p>
              The Bug and Frog Foundation supports NICU families with direct
              funding and LilyPad, a single app that brings essential resources together:
              assistance applying for programs like WIC and Medicaid, requesting care packages
              with clothing, formula, and supplies, financial subsidies, and replacing breast pump parts.
            </p>
            <p className="last-line">
              No more ill-fitting clothes, overdue parking fees, or missed
              paperwork. We're here to help take care of families, so they can take care of
              their babies.
            </p>
            <div className="hero-actions">
              <Link to="/intake" className="btn btn-outline">
                Request support
              </Link>
              <Link to="/donate" className="btn btn">
                Donate
              </Link>
            </div>
          </div>
          <div className="hero-art">
            <img
              src="/assets/hero.png"
              alt="The Bug and Frog Foundation mascots"
            />
          </div>
        </div>
      </section>

      <section className="section-alt">
        <div className="container">
          <div className="section-heading">
            <h2>What We Fund</h2>
            <p>
              From financial assistance to care packages to breast pump supplies, we're exapanding
              our support every day to make the NICU experience a little easier for everyone.
            </p>
          </div>
          <div className="funding-grid">
            <div className="funding-card">
              <h3>Financial support</h3>
              <p>Most financial programs require your NICU stay be at least 30 days before they
                assist. We offer subsidies for parking,
                meals, and other unexpected costs, regardless of your stay. </p>
            </div>
            <div className="funding-card">
              <h3>Preemie care packages</h3>
              <p>Hospital clothes are oversized and scratchy. Antibacterial handsoap destroys your skin 
                barrier. Request a care package for baby <i>and</i> caregiver for all your NICU essentials.
              </p>
            </div>
            <div className="funding-card">
              <h3>Social program assistance</h3>
              <p>Social programs, like WIC and Medicaid, can be difficult to navigate, and even harder when you're
                looking after your little bug. Let us help you with the administrative work.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <div className="section-heading">
            <h2>Partners and Volunteering</h2>
            <p>
              Volunteer programs and organizations our foundation endorses. Come join and
              support our beautiful community!
            </p>
          </div>
          <div className="support-grid">
            <div className="support-item">
              <h3>Partnerships</h3>
              <div className="partner-logos">
                <a href="https://www.lotusdisability.com/" target="_blank" rel="noopener noreferrer">
                  <img
                    src="/assets/partner-lotus-disability.png"
                    alt="Lotus Disability"
                    className="partner-logo"
                  />
                </a>
              </div>
              <p>Email <a href="mailto:info@bugandfrog.org">info@bugandfrog.org</a> to partner with us!</p>
            </div>
            <div className="support-item">
              <h3>Volunteer Programs</h3>
              <div className="partner-logos">
                <Link to="/volunteer/busy-bees" className="volunteer-logo-link">
                  <img
                    src="/assets/busy-bees-logo.png"
                    alt="Busy Bees"
                    className="volunteer-logo"
                    width="600"
                    height="470"
                  />
                </Link>
              </div>
              <p>
                Email <a href="mailto:volunteer@bugandfrog.org">volunteer@bugandfrog.org</a> for other
                volunteering opportunities.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
